export default {
  'menu.login': '登录',
  'menu.dashboard': '仪表盘',

  // 用户管理
  'menu.users': '用户管理',
  'menu.users.list': '用户列表',
  'menu.users.wallets': '钱包连接',
  'menu.users.detail': '用户详情',

  // 矿机管理
  'menu.miners': '矿机管理',
  'menu.miners.products': '矿机产品',

  // 订单管理
  'menu.orders': '订单管理',

  // 票券管理
  'menu.tickets': '票券管理',
  'menu.tickets.products': '票券商品',

  // 提现管理
  'menu.withdrawals': '提现管理',
  'menu.withdrawals.pending': '待审核',
  'menu.withdrawals.history': '提现历史',

  // 活动管理
  'menu.activities': '活动管理',
  'menu.activities.dailyPool': '每日奖池',
  'menu.activities.dailyPoolDetail': '奖池详情',
  'menu.activities.social': '社交活动',
  'menu.activities.socialDetail': '活动详情',
  'menu.activities.tasks': '任务管理',
  'menu.activities.promotions': '促销活动',

  // 站内信管理
  'menu.messages': '站内信',
  'menu.messages.list': '消息列表',
  'menu.messages.send': '发送消息',

  // 数据分析
  'menu.analytics': '数据分析',

  // 渠道统计
  'menu.channels': '渠道统计',

  // 行为分析
  'menu.analyticsEvents': '行为分析',

  // 交易记录
  'menu.transactions': '交易记录',

  // 支付管理
  'menu.payments': '支付管理',
  'menu.payments.unmatched': '未匹配支付',
  'menu.reconciliation': '钱包对账',

  // 系统设置
  'menu.settings': '系统设置',

  // 系统管理
  'menu.system': '系统管理',
  'menu.system.accounts': '账户管理',
  'menu.system.roles': '角色管理',

  // 账户
  'menu.account': '账户',
  'menu.account.logout': '退出登录',

  // 异常页
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
};
